import { observer } from 'mobx-react-lite';
import { SyntheticEvent, useState } from 'react';
import { Button, Divider, Form, Modal, Select } from 'semantic-ui-react';
import { DeliveryRequest } from '../../models/deliveryRequest';
import { useStore } from '../../stores/store';
import {
  ApproveOptions,
  ApproveOptions1,
  DenyOptions,
} from '../options/otherOptions/approveOptions';
import { Activity } from '../../models/activity';
import sendRespectiveEmail from '../../models/EmailNew';
import { userLanguage } from '../userLanguageSchema/userLanguage';

function ApproveModalDelivery() {
  const {
    dashboardStore: { dashboard, DenialModalOpen },
    activityStore: { selectedActivity },
    DeliveryStore: {
      approveRegistry,
      listApproveDelivery,
      listAssignPickerDelivery,
      listCreateOrder,
      ApproveDelivery,
    },
    commonStore,
  } = useStore();
  const [, setOpen] = useState(false);
  const [comments, setComments] = useState('');

  const handleChange = (e: SyntheticEvent, data: any) => {
    setComments(data.value);
  };
  //////////////////////////////////////Delivery
  const DeliveryDataAPICall = async (
    delivery: DeliveryRequest,
    Activity: Activity,
    value: boolean,
    comments: string,
    status: string,
  ) => {
    const newArr = {
      ...delivery,
      isApproved: value,
      approvalOrDenialComments: comments,
    }; // Appending Delivery
    const ActivityArr = {
      ...Activity,
      asset_tracking_status: status,
      assignedUsers: [],
      movementdate: new Date().toISOString(),
      last_modified: new Date().toISOString(),
      itemDeliveryRequest: [newArr],
    }; // Appending Data To Activity
    // activityStore.updateActivityProcessDelivery(newArr); // Updating Activity
    const response = await ApproveDelivery(
      newArr.id,
      newArr.isApproved,
      comments,
    );
    sendRespectiveEmail(
      'Notification',
      ActivityArr.title,
      'Updated Delivery Approve',
      '',
      `${ActivityArr.type} is Delivery Approval Approved successfully on`,
    );
    setComments('');
    setTimeout(() => {
      if (response.includes('denied')) {
        commonStore.updateHistoryAlonePOST(
          `Order register placed on the asset ${selectedActivity?.title} is denied due to reason: ${comments}`,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
      } else if (response.includes('approved')) {
        commonStore.updateHistoryAlonePOST(
          response,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
      } else {
        commonStore.updateHistoryAlonePOST(
          response,
          selectedActivity?.id,
          undefined,
          true,
          true,
        );
      }
    }, 200);
  };

  const EditFunction = () => {
    if (selectedActivity !== undefined) {
      // global values
      const Activity: Activity = selectedActivity;
      const delivery: DeliveryRequest = approveRegistry
        .get(selectedActivity?.id)
        .itemDeliveryRequest?.filter(
          (i: { isActive: boolean }) => i.isActive === true,
        )?.[0];
      const boolVal = dashboard.ApproveDenialHeader === 'Deny' ? false : true;
      const message = boolVal ? 'Approved' : 'Denied';

      // conditions
      // item delivery request approve
      if (dashboard.valueForL3Inventory === 'Approve') {
        DeliveryDataAPICall(
          delivery,
          Activity,
          boolVal,
          comments,
          `Delivery Asset ${message}`,
        );
        // sending History
        // updateHistoryfunction(`Asset ${message} for Assigning Picker`, Activity)
      }
      setTimeout(() => {
        if (
          dashboard.L2CardValueInventory === 'Delivery' &&
          dashboard.valueForL3Inventory === 'Approve'
        ) {
          listApproveDelivery();
        }
        if (
          dashboard.L2CardValueInventory === 'Delivery' &&
          dashboard.valueForL3Inventory === 'Assign Picker Delivery'
        ) {
          listAssignPickerDelivery();
        }
        if (
          dashboard.L2CardValueInventory === 'Delivery' &&
          dashboard.valueForL3Inventory === 'Create Order'
        ) {
          listCreateOrder();
        }
      }, 1000);

      DenialModalOpen(false, '', false, '');
      if (boolVal) {
        dashboard.valueForL3Inventory = 'Assign Picker Delivery';
      } else {
        dashboard.valueForL3Inventory = 'Order Register';
      }
    }
  };
  return (
    <Modal
      onClose={() => setOpen(false)}
      onOpen={() => setOpen(true)}
      open={dashboard.DenialModal}
    >
      <Modal.Header>Reason For {dashboard.ApproveDenialHeader}</Modal.Header>
      <Modal.Content>
        <Modal.Description>
          <Form>
            <Form.TextArea
              label={
                (
                  userLanguage[0].InventoryDeliveryApproveComponent
                    .IDACM02 as any
                )?.[`${commonStore.language.key}`]
              } //comments
              placeholder={
                (
                  userLanguage[0].InventoryDeliveryApproveComponent
                    .IDACMPH01 as any
                )?.[`${commonStore.language.key}`]
              } //Please Specify a reason'
              maxLength="500"
              name="comments"
              value={comments}
              onChange={handleChange}
              //Or
            />
          </Form>
          <Divider horizontal>
            {
              (
                userLanguage[0].InventoryDeliveryApproveComponent.IDACB02 as any
              )?.[`${commonStore.language.key}`]
            }
          </Divider>
          <Form>
            <Form.Field
              id="Type"
              options={
                dashboard.ApproveDenialHeader === 'Deny'
                  ? DenyOptions
                  : dashboard.ApproveDenialHeader === 'Approve'
                    ? ApproveOptions1
                    : ApproveOptions
              }
              control={Select}
              label={
                (
                  userLanguage[0].InventoryDeliveryApproveComponent
                    .IDACML01 as any
                )?.[`${commonStore.language.key}`]
              } //"Reasons"
              name="comments"
              placeholder=""
              clearable
              value={comments}
              onChange={handleChange}
            />
          </Form>
        </Modal.Description>
      </Modal.Content>
      <Modal.Actions>
        <Button
          color="black"
          onClick={() => DenialModalOpen(false, '', false, '')}
          //Cancel
        >
          {
            (
              userLanguage[0].InventoryDeliveryApproveComponent.IDACMB01 as any
            )?.[`${commonStore.language.key}`]
          }
        </Button>
        <Button
          content={
            (
              userLanguage[0].InventoryDeliveryApproveComponent.IDACMB02 as any
            )?.[`${commonStore.language.key}`]
          } //"Save"
          labelPosition="right"
          icon="checkmark"
          onClick={EditFunction}
          positive
          disabled={comments.length < 1 ? true : false}
        />
      </Modal.Actions>
    </Modal>
  );
}
export default observer(ApproveModalDelivery);
